<template>
    <div class="Credentials">
        <div class="header">
            <div class="title tipColor">{{ infoHtml.name }}</div>
            <div class="right" @click="onBack">
                <div class="tips">
                    点击关闭即可返回自助大厅
                    <i class="el-icon-caret-right"></i>
                </div>
                <img loading="lazy"
                    v-lazy="require('../../../assets/images/dze/close.png')"
                    class="closeimg"
                />
            </div>
        </div>

        <div class="card">
            <p class="title fullColor">{{ $t("credentials.name") }}</p>
            <div class="flexbox borderB" v-if="listData.length > 0">
                <!-- <swiper class="swiper" :options="swiperOption">
                    <swiper-slide v-for="(item, i) of listData" :key="i">
                        <div class="one">
                            <img loading="lazy"
                                src="../../../assets/images/dze/succes.png"
                                class="img"
                                v-if="item.flag"
                            />
                            <img loading="lazy"
                                src="../../../assets/images/dze/tips.png"
                                class="img"
                                v-if="!item.flag"
                                alt=""
                            />
                            <p class="textcolor" :class="{ flagF: !item.flag }">
                                {{ item | codeName(that) }}
                            </p>
                        </div>
                    </swiper-slide> -->
                <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
                <!-- </swiper> -->
                <div class="left">
                    <div class="one" v-for="(item, i) of listData" :key="i">
                        <img loading="lazy"
                            v-lazy="require('../../../assets/images/dze/succes.png')"
                            class="img"
                            v-if="item.flag"
                        />
                        <img loading="lazy"
                            v-lazy="require('../../../assets/images/dze/tips.png')"
                            class="img"
                            v-if="!item.flag"
                            alt=""
                        />
                        <p class="textcolor" :class="{ flagF: !item.flag }">
                            {{ item | codeName(that) }}
                        </p>
                    </div>
                </div>

                <div class="right">
                    <p class="money">{{ amount }}</p>
                    <p class="textcolor">{{ $t("credentials.text3") }}</p>
                </div>
            </div>
            <div class="flexbox space-between">
                <p>
                    <span class="tipColor">{{ $t("credentials.text7") }}</span>
                    <span class="textcolor">
                        {{ $t("credentials.text4") }}
                    </span>
                    <span class="text" @click="goPage">
                        {{ $t("credentials.text5") }}
                    </span>
                </p>
                <el-button
                    class="btnclear"
                    @click="onRievle"
                    :class="{ btnred: btnShow }"
                >
                    {{ btnText }}
                </el-button>
            </div>
        </div>

        <div class="tipbox">
            <p class="tipColor">
                {{ $t("credentials.text8") }}
            </p>
            <p class="fullColor">
                {{ $t("credentials.text9") }}
                <span class="">{{ datainfo.deposit }}</span>
                {{ $t("credentials.text91") }}
            </p>
            <p class="fullColor">{{ $t("credentials.text10") }}</p>
            <p class="fullColor">
                {{ $t("credentials.text11") }}
                <span class="remk" @click="openDetail">
                    {{ $t("credentials.text12") }}
                </span>
                {{ $t("credentials.text13") }}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    filters: {
        codeName(value, that) {
            let str = "";
            switch (value.conditionCode) {
                case "realName":
                    str = that.language.realName;
                    break;
                case "email":
                    str = that.language.email;
                    break;
                case "phone":
                    str = that.language.phone;
                    break;
                case "qq":
                    str = that.language.qq;
                    break;
                case "safePassword":
                    str = that.language.safePassword;
                    break;
                case "bank":
                    str = that.language.bank1;
                    break;
                case "digitalCurrency":
                    str = that.language.digitalCurrency;
                    break;
                case "origin":
                    str = that.language.origin;
                    break;
                case "deposit":
                    str =
                        that.language.text1 + value.value + that.language.text2;
                    break;
            }
            return str;
        },
    },
    data() {
        return {
            id: "",
            datainfo: {},
            amount: 0,
            btnText: "未达到领取要求",
            listData: [],
            infoHtml: {},
            that: this,
            swiperOption: {
                slidesPerView: 6,
                spaceBetween: 30,
                freeMode: true,
            },
            btnShow: false,
        };
    },
    computed: {
        language() {
            return this.$t("credentials");
        },
    },
    created() {
        this.id = this.$route.query.id;
        this.getData();
    },
    methods: {
        getData() {
            this.$http
                .get(this.$api.getThematicActivitiesByApp + "/" + this.id)
                .then((res) => {
                    if (res.code == 0) {
                        this.infoHtml = res.data;
                        this.datainfo = res.data.infoAuthVO;
                        this.amount = this.datainfo.amount;
                        this.listData = this.datainfo.list;
                        if (this.datainfo.status == 0) {
                            this.btnText = this.$t("credentials.failed");
                            this.btnShow = false;
                        } else if (this.datainfo.status == 1) {
                            this.btnText = this.$t("credentials.received");
                            this.btnShow = true;
                        } else {
                            this.btnText = this.$t("credentials.receivedt");
                            this.btnShow = false;
                        }
                    }
                });
        },
        onRievle() {
            if (!this.datainfo.flag) {
                return;
            }
            this.$http.put(this.$api.getReceive + this.id).then((res) => {
                if (res.code == 0) {
                    this.$message.success(this.$t("myPage.titleAlert"));
                    this.getData();
                    this.$nkhttp.getuserMoney();
                }
            });
        },
        goPage() {
            this.listData.forEach((element) => {
                if (!element.flag) {
                    switch (element.conditionCode) {
                        case "realName":
                            this.$router.push("/my/info/account");
                            break;
                        case "email":
                            this.$router.push("/my/info/account");
                            break;
                        case "phone":
                            this.$router.push("/my/info/account");
                            break;
                        case "qq":
                            this.$router.push("/my/info/account");
                            break;
                        case "safePassword":
                            this.$router.push("/my/security/verification");
                            break;
                        case "bank":
                            this.$router.push("/my/info/bankCard");
                            break;
                        case "digitalCurrency":
                            this.$router.push("/my/info/bankCard");
                            break;
                        case "origin":
                            this.$router.push("/my/info/bankCard");
                            break;
                        case "deposit":
                            this.$router.push("/my/finance/deposit");
                            break;

                        default:
                            break;
                    }
                }
            });
        },
        openDetail() {
            this.$router.push({
                path: "/discount",
                query: {
                    flag: true,
                    name: this.infoHtml.name,
                    startTime: this.infoHtml.startTime,
                    endTime: this.infoHtml.endTime,
                    forever: this.infoHtml.forever,
                },
            });
            localStorage.setItem("disIntro", this.infoHtml.intro);
        },
        onBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="scss" scope >
    @import url('../../../assets/css/common.css');
.swiper {
}
.swiper-container {
    margin-left: 0;
}
.Credentials {
    .header {
        // padding: 10px 0;
        margin: 20px 0;
        .title {
            font-size: 14px;
            border-bottom: 2px solid #e91919;
            padding: 0px 60px 20px 60px;
        }
        .right {
            cursor: pointer;
        }
        .tips {
            border: 1px solid #e0e0e0;
            border-radius: 20px;
            color: #999;
            font-size: 12px;
            padding: 5px 10px;
            display: inline-block;
            margin-right: 10px;
        }
        border-bottom: 1px solid #e8e8e8;
    }
    .closeimg {
        width: 31px;
        height: 31px;
    }
    .card {
        border-radius: 4px;
        border: 1px solid #dcdcdc;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        padding: 12px 12px 0px 12px;
        margin-bottom: 58px;
        .title {
            font-size: 14px;
        }
        .flexbox {
            display: flex;
            align-items: center;
            padding: 15px 0;
            .item {
                text-align: center;
                padding: 0 30px;
                line-height: 2;
                margin-right: 60px;
            }
            .left {
                flex-grow: 2;
                display: flex;
                flex-wrap: wrap;
            }
            .one {
                text-align: center;
                line-height: 2;
                min-width: 130px;
                margin-top: 10px;
                margin-bottom: 10px;
            }
            .right {
                text-align: center;
                line-height: 2;
                border-left: 1px solid #dcdcdc;
                padding-left: 44px;
                flex-shrink: 0;
                .money {
                    font-weight: bold;
                    color: #e91919;
                    font-size: 15px;
                }
            }
            .img {
                width: 24px;
                height: 24px;
            }
            .text {
                color: #2ba8ff;
                cursor: pointer;
            }
            .btnclear {
                font-size: 12px;
                width: 120px;
                border: none;
                border: 1px solid #e6e6e6;
                background: #f5f5f5;
                color: #909090;
            }
            .btnred {
                background: #e91919;
                color: #fff;
            }
        }
        .borderB {
            border-bottom: 1px solid #e8e8e8;
        }
        .space-between {
            justify-content: space-between;
        }
    }
    .tipColor {
        color: #e91919;
    }
    .fullColor {
        color: #333;
    }
    .textcolor {
        color: #999;
    }
    .flagF {
        color: #ff3a2b !important;
    }
    .font {
        font-size: 12px;
    }
    .remk {
        color: #0066ff;
        cursor: pointer;
        border-bottom: 1px solid;
    }
    .tipbox {
        p {
            line-height: 2.5;
        }
    }
}
</style>